import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { MarketingChannel } from "../../marketing";

export enum MarketingConversationType {
  RECOVER = "RECOVER",
}

export enum MarketingConversationPriority {
  LEVEL_1 = 1,
  LEVEL_2 = 2,
}

const marketingConversationBaseSchema_ = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  customerId: zExt.objectId(),
  lastMessageAt: z.date(),
  lastInitialMessageAt: z.date().optional(),
  priority: createEnum(MarketingConversationPriority),
});

const smsMarketingConversationSchema_ = marketingConversationBaseSchema_.extend(
  {
    type: createEnum(MarketingConversationType),
    channel: z.literal(MarketingChannel.SMS),
    customerPhoneNumber: z.string(),
  },
);

const emailMarketingConversationSchema_ =
  marketingConversationBaseSchema_.extend({
    type: createEnum(MarketingConversationType),
    channel: z.literal(MarketingChannel.EMAIL),
    customerEmail: z.string(),
  });

const marketingConversationSchema_ = z.discriminatedUnion("channel", [
  smsMarketingConversationSchema_,
  emailMarketingConversationSchema_,
]);

export const marketingConversationSchema: z.ZodType<MarketingConversation> =
  marketingConversationSchema_;

export type MarketingConversation = z.infer<
  typeof marketingConversationSchema_
>;

export type SmsMarketingConversation = z.infer<
  typeof smsMarketingConversationSchema_
>;
export type EmailMarketingConversation = z.infer<
  typeof emailMarketingConversationSchema_
>;

const smsMarketingConversationHydratedSchema_ =
  smsMarketingConversationSchema_.extend({
    customerName: z.string().optional(),
    teamName: z.string().optional(),
  });

const emailMarketingConversationHydratedSchema_ =
  emailMarketingConversationSchema_.extend({
    customerName: z.string().optional(),
    teamName: z.string().optional(),
  });

const marketingConversationHydratedSchema_ = z.discriminatedUnion("channel", [
  smsMarketingConversationHydratedSchema_,
  emailMarketingConversationHydratedSchema_,
]);

export const marketingConversationHydratedSchema: z.ZodType<MarketingConversationHydrated> =
  marketingConversationHydratedSchema_;

export type MarketingConversationHydrated = z.infer<
  typeof marketingConversationHydratedSchema_
>;

export type SmsMarketingConversationHydrated = z.infer<
  typeof smsMarketingConversationHydratedSchema_
>;

export type EmailMarketingConversationHydrated = z.infer<
  typeof emailMarketingConversationHydratedSchema_
>;
